import { render, staticRenderFns } from "./UserPointShortage.vue?vue&type=template&id=50bfe150"
import script from "./UserPointShortage.vue?vue&type=script&lang=js"
export * from "./UserPointShortage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports